import { createFileRoute, redirect } from '@tanstack/react-router';

/* Il vecchio gantt interattivo è stato tolto il 26-10-2026: frecce e avanzamento stanno ora nel
   gantt della sezione. Tiene vivi i vecchi link. */
export const Route = createFileRoute('/_app/tasks/gantt-interactive')({
  beforeLoad: () => { throw redirect({ to: '/tasks/gantt', replace: true }); },
});
